/**
 * Унифицированные стили для Card компонентов
 * Используются в ChartBlock компонентах для консистентности
 */

/**
 * Базовые стили для Card в ChartBlock (модальное окно)
 */
export const CHART_BLOCK_CARD_CLASSES = "w-full bg-white flex flex-col p-4! gap-4!";

/**
 * Стили для CardHeader в ChartBlock
 */
export const CHART_BLOCK_HEADER_CLASSES = "p-0! gap-0! flex-shrink-0";

/**
 * Стили для CardContent в ChartBlock
 */
export const CHART_BLOCK_CONTENT_CLASSES = "p-0!";

/**
 * Стили для CardTitle в ChartBlock
 */
export const CHART_BLOCK_TITLE_CLASSES = "text-base font-semibold";
